export default {
  props: {
    groups: {
      type: Array,
      required: true
    }
  }
}
